export default "__VITE_ASSET__3b7e5bbc__"